
  import ScreenSize from '@/mixins/ScreenSize';
  import {prepareImageUrl} from '@/helper/ImageHelper';
  export default {
    name: 'SectionCitySheet',
    components: {
      CustomSheet: () => import('@/components/CustomSheet'),
      CustomCompactSheet: () => import('@/components/CustomCompactSheet'),
    },
    mixins: [ScreenSize],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
      loggedIn: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    serverCacheKey: function (props) {
      return (
        'section-city-sheet-' +
        props.section.id +
        '-' +
        (props.section.route_name
          ? props.section.route_name
          : 'landingpages-cities-city')
      );
    },
    data() {
      return {
        sheetElements: [],
      };
    },
    created() {
      // prepare carousel items
      if (this.section.cities) {
        this.section.cities.forEach((city) => {
          if (
            this.section.appearance &&
            ((this.section.appearance === 'large' &&
              city.card_image !== null) ||
              this.section.appearance === 'compact')
          ) {
            // differ target link for routing
            const params = {};
            const route_name = this.section.route_name
              ? this.section.route_name
              : 'landingpages-cities-city';
            params.city = city.slug;

            if (this.section.city) {
              params.city = this.section.city.slug;
            }

            const route = {
              name: route_name,
              params: params,
            };

            let link_title = '';
            if (this.section.link_title) {
              link_title = this.section.link_title.replace(
                /%city_name/g,
                city.name
              );
            }

            this.sheetElements.push({
              text: city.title,
              image: prepareImageUrl(city.card_image.url),
              link: this.localePath(route),
              link_title: link_title,
            });
          }
        });
      }
    },
  };
